export default __webpack_public_path__ + "static/summer_containers50-ac2f9d0852f0b200c596b06c480b0e3b.webp";